import { getFromStorage } from "../../used-vue/api/Storage";

function toggleElementsBasedOnFinanceModified(isModified = false) {
    const termsElements = document.querySelectorAll('.finance-terms__personal-quote');
    const displayType = (isModified === true) ? 'inline' : 'none';

    termsElements.forEach(termsElement => {
        termsElement.style.display = displayType;
    })
}

window.addEventListener('new_finance_modified', event => {
    toggleElementsBasedOnFinanceModified(event.detail.modified);
});

export default function() {
    toggleElementsBasedOnFinanceModified((getFromStorage('new_finance_modified') == 'Y'));
}


// WEBPACK FOOTER //
// ./resources/assets/js/core/modules/toggle-personal-quote-terms.js